import { asyncThunkWrapper } from "../thunkHandler"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { BASEURI, headers } from "../../utils/helper"

// Create blog request
export const createBlog = createAsyncThunk(
  "create",
  async (data, thunkAPI) => {
    return asyncThunkWrapper(
      {
        data,
        method: "POST",
        headers: {
          ...headers(),
          "Content-Type": "multipart/form-data"
        },
        url: `${BASEURI}/specialist/blog/create`,
      },
      thunkAPI
    )
  }
)

// Retrieve blog request
export const retrieveAllBlogs = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      limit: data?.limit || null,
      search: data?.search || null,
      currentPage: data?.currentPage || null,
    }

    return asyncThunkWrapper(
      {
        params,
        method: "GET",
        headers: {
          ...headers(),
          "Content-Type": "multipart/form-data"
        },
        url: `${BASEURI}/specialist/blog/retrieve-all`,
      },
      thunkAPI,
      {
        toast: false
      }
    )
  }
)